
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SalesRatioControlFormHintBanner',
  props: {},
  setup() {
    return {};
  }
});
